const BlankPageLayer = () => {
  return <div></div>;
};

export default BlankPageLayer;
